const VARIANTS = {
  new:       { label: "New",       cls: "bg-[#E8F1F4] text-[#1F4A56] border-[#B8D5DD]" },
  contacted: { label: "Contacted", cls: "bg-amber-50  text-amber-800   border-amber-200" },
  qualified: { label: "Qualified", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  won:       { label: "Won",       cls: "bg-emerald-100 text-emerald-900 border-emerald-300" },
  lost:      { label: "Lost",      cls: "bg-slate-100 text-slate-700 border-slate-200" },
};

export default function StatusBadge({ value, className = "" }) {
  const v = VARIANTS[value] || VARIANTS.new;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider ${v.cls} ${className}`}
      data-testid={`status-badge-${value}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {v.label}
    </span>
  );
}

export const STATUS_OPTIONS = ["new", "contacted", "qualified", "won", "lost"];
